import Util from '@/lib/util'
export default [
    {
        title:Util.L('Order'),
        key:'orderNo',
        width:70
    },
    {
        title:Util.L('SKU'),
        key:'sku'
    },
    {
        title:Util.L('ProductName'),
        key:'productName'
    },
    {
        title:Util.L('OrderQty'),
        width: 100,
        key:'orderQty',
        align: "right",
        render: (h:any,params:any) =>{
            return h('span', Util.toViewNumberString(params.row.orderQty));
        }
    },
   
    {
        title:Util.L('PickedQty'),
        width: 100,
        key:'outPickedQty',
        align: "right",
        render: (h:any,params:any) =>{
            return h('span', Util.toViewNumberString(params.row.outPickedQty));
        }
    },
    {
        title:Util.L('PackedQty'),
        align: 'right',
        width: 100,
        key:'outPackedQty',
        render: (h:any,params:any) =>{
            return h('span', Util.toViewNumberString(params.row.outPackedQty));
        }
    },
    {
        title:Util.L('ReceivedQty'),
        width: 100,
        key:'inReceivedQty',
        align: "right",
        render: (h:any,params:any) =>{
            return h('span', Util.toViewNumberString(params.row.inReceivedQty));
        }
    }
]